import { render, staticRenderFns } from "./proveedor.vue?vue&type=template&id=e92f51ea&"
import script from "./proveedor.vue?vue&type=script&lang=js&"
export * from "./proveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports